<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="54"
    height="55"
    viewBox="0 0 54 55"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.0625 27.5C5.0625 15.3837 14.8837 5.5625 27 5.5625C39.1162 5.5625 48.9375 15.3837 48.9375 27.5C48.9375 39.6162 39.1162 49.4375 27 49.4375C14.8837 49.4375 5.0625 39.6162 5.0625 27.5ZM35.1225 23.4185C35.2575 23.2386 35.3552 23.0336 35.4098 22.8154C35.4644 22.5972 35.4749 22.3703 35.4405 22.148C35.4062 21.9258 35.3278 21.7126 35.2099 21.5211C35.092 21.3295 34.9371 21.1635 34.7541 21.0327C34.5711 20.9019 34.3638 20.809 34.1444 20.7595C33.9251 20.71 33.698 20.7048 33.4766 20.7443C33.2552 20.7838 33.0439 20.8671 32.8551 20.9894C32.6664 21.1117 32.504 21.2705 32.3775 21.4565L25.0965 31.649L21.4425 27.995C21.1226 27.6969 20.6995 27.5346 20.2623 27.5424C19.8251 27.5501 19.408 27.7272 19.0989 28.0364C18.7897 28.3455 18.6126 28.7626 18.6049 29.1998C18.5971 29.637 18.7594 30.0601 19.0575 30.38L24.12 35.4425C24.2932 35.6156 24.5021 35.7489 24.732 35.8332C24.9619 35.9175 25.2074 35.9507 25.4515 35.9306C25.6955 35.9105 25.9323 35.8375 26.1453 35.7167C26.3583 35.5959 26.5425 35.4301 26.685 35.231L35.1225 23.4185Z"
      fill="#039855"
    />
  </svg>
</template>
